export const userRoles = {
  admin: 'Admin',
  user: 'User',
  trainee: 'Trainee',
} as const;

export type IUserRole = typeof userRoles[keyof typeof userRoles];
